module.exports = __webpack_public_path__ + "static/media/crop-logo.39d19ad0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/crop-logo.png
// module id = 245
// module chunks = 2